import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import RiskAssessmentForm from "./RiskAssessmentForm";
import { Button, Col, Row, Segmented } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import EditIcon from "../../../ui/EditIcon";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import RiskAssessmentSummary from "./RiskAssessmentSummary";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import RiskAnalysis from "../../../../assets/doctorIcons/risk-analysis.svg";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import useQuery from "../../../../hooks/useQuery";
import useIsMobile from "../../../../hooks/useIsMobile";
import "../../Doctor/DailyReview/DailyReview.css";

const RiskAssessment = ({
  riskAssessment,
  refreshPage,
  patientData,
  iAssessment,
}) => {
  const [visible, setVisible] = useState(false);
  const [activeSegment, setActiveSegment] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [newReview, setNewReview] = useState(false);
  const [riskRefresh, setRiskRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const riskAssessmentRefresh = () => {
    setRiskRefresh((prev) => !prev);
  };
  const isActive = useQuery()?.status === "current";
  const isMobile = useIsMobile();

  useEffect(() => {
    if (riskAssessment) setLoading(false);
    if (riskAssessment?.length > 0) {
      setActiveSegment(riskAssessment[0]?.id);
    }
  }, [riskAssessment]);

  const segmentData = riskAssessment?.map((item) => ({
    label: `${dayjs(item?.created_at).format("MMM DD")}, ${dayjs(
      item?.created_at
    ).format("h:mm A")}`,
    value: item?.id,
  }));

  const handleAddReview = () => {
    setEditMode(false);
    setActiveSegment(null);
    setVisible(true);
    setAddMode(true);
    setNewReview(riskAssessment?.length === 0);
  };

  const handleEditReview = () => {
    setEditMode(true);
    setVisible(true);
  };

  return (
    <>
      {loading ? (
        <LoadingIndicator message={"Loading..."} />
      ) : (
        <>
          {riskAssessment?.length > 0 ? (
            <Row gutter={[12, 12]} className="daily-review-page">
              <Col span={24}>
                <div className="daily-review-toolbar">
                  <div className="daily-review-toolbar__left">
                    {isActive && (
                      <Button
                        type="primary"
                        onClick={handleAddReview}
                        className={`${btnStyles.lgBtn} inv-btn daily-review-toolbar__add`}
                        style={{ marginRight: "15px", fontWeight: 500 }}
                      >
                        <PlusOutlined /> Risk Assessment
                      </Button>
                    )}
                    <div className="daily-review-toolbar__dates">
                      <Segmented
                        className="daily-review-date-segment"
                        value={activeSegment}
                        options={segmentData}
                        onChange={setActiveSegment}
                        size="middle"
                        style={{
                          boxShadow: "2px 2px 3px #e3e4e6",
                        }}
                      />
                    </div>
                  </div>

                  {isActive && (
                    <Button
                      type="primary"
                      onClick={handleEditReview}
                      className={`${btnStyles.lgBtn} inv-btn daily-review-toolbar__edit`}
                      disabled={!activeSegment}
                      style={{ fontWeight: 500 }}
                    >
                      <EditIcon />
                      Edit
                    </Button>
                  )}
                </div>
              </Col>
              <Col span={24}>
                <RiskAssessmentSummary
                  editId={activeSegment}
                  riskAssessmentRefresh={riskAssessmentRefresh}
                  isActive={isActive}
                  onEdit={handleEditReview}
                  canEdit={!!activeSegment}
                />
              </Col>
            </Row>
          ) : (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: isMobile ? "auto" : "80vh",
                padding: isMobile ? "24px 0 32px" : undefined,
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                <NoDataPage
                  title={"Risk Assessment Not Yet Submitted "}
                  subtitle={isActive && "Kindly, upload a risk assessment here"}
                  image={RiskAnalysis}
                />
                {isActive && (
                  <Button
                    type="primary"
                    onClick={handleAddReview}
                    className={`${btnStyles.lgBtn} inv-btn `}
                    style={{ fontWeight: "normal" }}
                  >
                    Risk Assessment Form
                  </Button>
                )}
              </Col>
            </Row>
          )}
        </>
      )}
      {visible && (
        <RiskAssessmentForm
          visible={visible}
          setVisible={setVisible}
          refreshPage={refreshPage}
          editId={editMode ? activeSegment : null}
          newReview={newReview}
          iAssessment={iAssessment}
          // reviewId={reviewId}
          addMode={addMode}
          setAddMode={setAddMode}
          setActiveSegment={setActiveSegment}
          riskAssessment={riskAssessment}
          riskAssessmentRefresh={riskAssessmentRefresh}
          riskRefresh={riskRefresh}
          segmentData={segmentData}
          patientData={patientData}
        />
      )}
    </>
  );
};

export default RiskAssessment;
